import s from "./TourIcons.module.scss";

export const DurationIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const StartTimeIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M7 3v3" />
    <path d="M17 3v3" />
    <rect x="4" y="5" width="16" height="16" rx="3" />
    <path d="M4 10h16" />
  </svg>
);

export const PeopleIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="9" cy="8" r="3" />
    <path d="M3.5 20c.6-4 2.7-6 5.5-6s4.9 2 5.5 6" />
    <circle cx="17" cy="9" r="2.5" />
  </svg>
);

export const DroneIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="2.5" />

    <circle cx="5" cy="5" r="2.5" />
    <circle cx="19" cy="5" r="2.5" />
    <circle cx="5" cy="19" r="2.5" />
    <circle cx="19" cy="19" r="2.5" />

    <path d="M7 7l3 3" />
    <path d="M17 7l-3 3" />
    <path d="M7 17l3-3" />
    <path d="M17 17l-3-3" />
  </svg>
);

export const CameraIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 8h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
    <path d="M9 8l1.2-2h3.6L15 8" />
    <circle cx="12" cy="13" r="3.5" />
  </svg>
);

export const PrivateTourIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 3l7 3v5c0 5-3.5 8-7 10-3.5-2-7-5-7-10V6z" />
    <path d="M9.5 12l1.8 1.8L15 10" />
  </svg>
);

export const PickupIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M3 16l1.2-5.2A2 2 0 0 1 6.1 9h11.8a2 2 0 0 1 1.9 1.8L21 16" />
    <path d="M5 16h14" />
    <circle cx="7" cy="18" r="1.8" />
    <circle cx="17" cy="18" r="1.8" />
    <path d="M7 9V6h10v3" />
  </svg>
);

export const SpotIcon = () => (
  <svg viewBox="0 0 64 64">
    <circle cx="32" cy="32" r="10" />
    <path d="M32 8v8" />
    <path d="M32 48v8" />
    <path d="M8 32h8" />
    <path d="M48 32h8" />
    <path d="M15 15l6 6" />
    <path d="M43 43l6 6" />
    <path d="M49 15l-6 6" />
    <path d="M21 43l-6 6" />
    <circle cx="48" cy="14" r="2" />
    <circle cx="18" cy="20" r="1.5" />
  </svg>
);

export const SurfingIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 16c2.5-2.4 5.5-2.4 8 0s5.5 2.4 8 0" />
    <path d="M3 20c2-1.2 4-1.2 6 0s4 1.2 6 0 4-1.2 6 0" />
    <path d="M6.5 12c3.3-2.8 7.4-3.7 11.8-2.3" />
    <path d="M11.5 6l2.3 3" />
    <circle cx="10.8" cy="4.2" r="1.6" />
  </svg>
);

export const JetIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M4 15h9.5c2.4 0 4.5-1.4 5.5-3.5l.5-1H15l-2-3H9l1.5 3H7.8A3.8 3.8 0 0 0 4 14.3V15Z" />
    <path d="M12.5 7.5l2.8-2.2" />
    <path d="M4 18c1.5-1 3-1 4.5 0s3 1 4.5 0 3-1 4.5 0 3 1 4.5 0" />
    <path d="M3 21c1.5-.8 3-.8 4.5 0s3 .8 4.5 0 3-.8 4.5 0 3 .8 4.5 0" />
  </svg>
);

export const EmptyHandIcon = () => (
  <svg viewBox="0 0 24 24">
    <rect x="5" y="8" width="10" height="11" rx="2" />
    <path d="M8 8V6.8A2 2 0 0 1 10 5h0a2 2 0 0 1 2 2v1" />
    <path d="M16.5 15l1.8 1.8L21 13.8" />
  </svg>
);

export const LanguageIcon = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" />
    <path d="M4 12h16" />
    <path d="M12 3c2 2.4 3 5.4 3 9s-1 6.6-3 9" />
    <path d="M12 3c-2 2.4-3 5.4-3 9s1 6.6 3 9" />
  </svg>
);

const TourIcons = ({ icon, text }) => {
  return (
    <span className={s.root}>
      {icon}
      {text}
    </span>
  );
};

export default TourIcons;
